export const UserRole = {
    STUDENT_CANDIDATE: 1,
    STUDENT: 2,
    TEACHER: 3,
    STUDENT_SELECTOR: 4
};

export const TermStatus = {
    QUIT: 1,
    TERM_BREAK: 2,
    CONTINUE: 3
};